import { render, staticRenderFns } from "./NewRoommateDialog.vue?vue&type=template&id=146a2ff9&scoped=true&"
import script from "./NewRoommateDialog.vue?vue&type=script&lang=js&"
export * from "./NewRoommateDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewRoommateDialog.vue?vue&type=style&index=0&id=146a2ff9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146a2ff9",
  null
  
)

export default component.exports